export default __webpack_public_path__ + "static/media/nyan-cat-dark.fce1b974.svg";